import React from 'react'

import styles from './background.module.scss'

function Background({ children }) {
  return <div className={styles.base}>{children}</div>
}

export default Background
